import React, { useState } from "react";
import { Form, FormGroup, Input, Alert } from "reactstrap";
import Button from "./Button";

import validateEmail from "../validation/emailValidation";
import validatePhoneNumber from "validation/phoneValidation";
import { pushToDataLayer } from "utils/gtm";

function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);

  React.useEffect(() => {
    const form = document.querySelector('.contact-form');

    const handleSubmit = (event) => {
      // Validate before allowing submission
      const { fullName, email, contactNumber, message } = formData;
      console.log("🚀 ~ form.addEventListener ~ formData:", formData)
      let formErrors = {};

      if (!fullName) formErrors.fullName = "Fullständiga namn är obligatoriskt";
      if (!email) formErrors.email = "E-post är obligatoriskt";
      else if (!validateEmail(email)) formErrors.email = "Ogiltig e-postadress";
      if (!contactNumber) formErrors.contactNumber = "Telefonnummer är obligatoriskt";
      else if (!validatePhoneNumber(contactNumber)) formErrors.contactNumber = "Ogiltigt svenskt telefonnummer";
      if (!message) formErrors.message = "Meddelande är obligatoriskt";

      if (Object.keys(formErrors).length > 0) {
        event.preventDefault(); // Stop form submission
        setErrors(formErrors);
      } else {
        // Form is valid, let it submit to FormSubmit.co
        pushToDataLayer({
          event: "form_submit",
          category: "email",
          action: "submit",
          label: "Kontakta oss",
        });
      }
    };

    form.addEventListener('submit', handleSubmit);

    return () => {
      form.removeEventListener('submit', handleSubmit);
    };
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: null });
    setSubmitError(null);
  };

  return (
    <>
      <Form
        className="contact-form"
        action="https://formsubmit.co/e4e0cbd3daf72ee9fa11a64bfe8fb498"
        method="POST"
      >
        <h2>Kontakta oss</h2>
        <FormGroup>
          <label>Fullständiga namn</label>
          <Input
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            placeholder="Fullständiga namn"
            type="text"
            className="contact-form-input"
            invalid={!!errors.fullName}
          />
          {errors.fullName && (
            <div className="text-danger">{errors.fullName}</div>
          )}
        </FormGroup>
        <FormGroup>
          <label>E-post</label>
          <Input
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="E-post"
            type="email"
            className="contact-form-input"
            invalid={!!errors.email}
          />
          {errors.email && <div className="text-danger">{errors.email}</div>}
        </FormGroup>
        <FormGroup>
          <label>Telefonnummer</label>
          <Input
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
            required
            type="tel"
            placeholder="+46 XX-XXX XX XX"
            patter="^(?:\+46|0046|0)(\s?\d{2}[-\s]?\d{3}[-\s]?\d{2}[-\s]?\d{2})$"
            className="contact-form-input"
            invalid={!!errors.contactNumber}
          />
          {errors.contactNumber && (
            <div className="text-danger">{errors.contactNumber}</div>
          )}
        </FormGroup>
        <FormGroup>
          <label>Meddelande</label>
          <Input
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="3"
            type="textarea"
            className="contact-form-input"
            invalid={!!errors.message}
          />
          {errors.message && (
            <div className="text-danger">{errors.message}</div>
          )}
        </FormGroup>
        <FormGroup>
          <Input type="hidden" name="_next" value="https://sugbil.nu/tack" />
        </FormGroup>
        <Button name="Skicka" type="submit" />
        {submitError && (
          <Alert color="danger" className="contact-form-error">
            {submitError}
          </Alert>
        )}
      </Form>
    </>
  );
}

export default ContactForm;
